<script lang="ts" setup>
import { computed } from 'vue';
import { REG_BASE_PWD, REG_PWD } from '@/constants/reg';
import { updatePassword } from '@/service/api/sys/account';
import type { Api } from '@/typings/api';
import BasicDialogForm from '@/components/advanced/basic-form/basic-dialog-form.vue';
import type { BasicForm } from '@/typings/basic-form';

/** @description: 密码修改 */
defineOptions({
  name: 'ChangePassword'
});
const props = defineProps<{
  userId?: string;
}>();

const show = defineModel<boolean>('show', { default: false, required: true });

const editData = computed(() => {
  return {
    id: props.userId
  };
});

const rules = computed(() => {
  return [
    {
      pattern: props.userId === undefined || props.userId === null ? REG_PWD : REG_BASE_PWD,
      message:
        props.userId === undefined || props.userId === null
          ? '密码格式不正确，6-18位字符，包含字母、数字、特殊字符其中任意两种'
          : '密码格式不正确，6-18位字符',
      trigger: ['blur', 'input']
    }
  ];
});

const fields: BasicForm.FieldSchema<{ oldPassword: string; newPassword: string } & Api.Common.CommonRecord>[] = [
  {
    key: 'oldPassword',
    title: '旧密码',
    ifShow: () => props.userId === undefined || props.userId === null,
    dataType: 'string',
    colSpan: 24,
    required: true,
    component: {
      type: 'NInput',
      props: {
        maxlength: 20,
        inputProps: {
          autocomplete: 'current-password'
        }
      }
    }
  },
  {
    key: 'newPassword',
    title: '新密码',
    dataType: 'string',
    colSpan: 24,
    required: true,
    rules: () => rules.value,
    component: {
      type: 'NInput',
      props: {
        type: 'password',
        maxlength: 18,
        inputProps: {
          autocomplete: 'new-password'
        }
      }
    }
  },
  {
    key: 'confirmPassword',
    title: '确认密码',
    dataType: 'string',
    colSpan: 24,
    required: true,
    rules: ({ data }) => {
      return [
        {
          validator: (_rule, val) => {
            if (val !== data.newPassword) {
              return new Error('与新密码不一致');
            }
            return true;
          },
          trigger: ['blur', 'input']
        }
      ];
    },
    component: {
      type: 'NInput',
      props: {
        type: 'password',
        maxlength: 18,
        inputProps: {
          autocomplete: 'new-password'
        }
      }
    }
  }
];
</script>

<template>
  <BasicDialogForm
    v-model:show="show"
    custom-title="修改密码"
    :operation="userId ? 'edit' : 'add'"
    :edit-data="editData"
    :save-fn="updatePassword"
    :update-fn="updatePassword"
    :fields="fields"
  ></BasicDialogForm>
</template>

<style scoped></style>
